module.exports = __webpack_public_path__ + "static/media/girl.9408a2d2.svg";